module.exports = __webpack_public_path__ + "static/media/1009799.07cce4de.jpg";